import { render, staticRenderFns } from "./WorkspaceSelection.vue?vue&type=template&id=2c8515a6&scoped=true"
import script from "./WorkspaceSelection.vue?vue&type=script&lang=ts"
export * from "./WorkspaceSelection.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceSelection.vue?vue&type=style&index=0&id=2c8515a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8515a6",
  null
  
)

export default component.exports